module.exports = __webpack_public_path__ + "img/sence-gyhlw.3c952f3a.png";